import { Inject, Injectable } from '@angular/core';
import { getCurrentSessionURL, identify, init } from '@fullstory/browser';
import { environment, ENV_PROD_BUILD } from '@y42/environment';

@Injectable({ providedIn: 'root' })
export class FullStoryService {
  constructor(@Inject(ENV_PROD_BUILD) private readonly production: boolean) {
    this.init();
  }

  setUser(id: string, user: { email: string; name: string }) {
    identify(id, user);
  }

  getCurrentSessionUrl(): string | null {
    // Passing `true` returns a URL that also includes the timestamp
    return getCurrentSessionURL(true);
  }

  private init() {
    console.debug(`[FullStory]: initializing`);
    return init({
      orgId: environment.full_story_org,
      devMode: !this.production,
      host: 'fsrelay.y42.dev',
      script: 'fsrelay.y42.dev/s/fs.js',
    });
  }
}
